// Import React and Hooks
import React, { useEffect } from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch } from '../hooks/useRedux'
// Import React Router Dom
import { useLocation } from 'react-router-dom'
import { openModalAction } from '../actions/modalAction'
import { downloadCurrentOfferingAction } from '../actions/offeringsAction'
// Import Components
import Button from './../components/ui/Button'
//import Background from '../components/layout/Background'
import { toCreateOfferingButton2 } from '../actions/datalayer'


const Offerings = () => {



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()

  function btnCrearOfrenda() {
    toCreateOfferingButton2();
  }



  // Use Location
  const location = useLocation()



  // Use Effect
  useEffect( () => {
      const urlFiles = window.location.host === 'localhost:3030' ? '../' : ( window.location.host === 'localhost:3000' ? '/3D/dist/' : `${window.drupalSettings.path.themeUrl}/experience/public/3D/dist/`)
      const scripts = [`${urlFiles}js/main.js`];
      scripts.forEach(function (script) {
        const scriptElement = document.createElement('script');
        scriptElement.setAttribute('src', script)
        document.body.insertAdjacentElement('beforeend', scriptElement);
      })
  }, [] )



  // Functions
  window.openOffering = ( id:number ) => {
    dispatch( downloadCurrentOfferingAction(id) )
    setTimeout( () => dispatch( openModalAction('offering') ), 750 )
  }



  return (
    <div className="w100">
      <section className="glassWall">
        <div className="glassWall__container">
        <Button
          type='animated'
          additionalClass="btn--offering"
          url='/cempasuchil/crear-ofrenda'
          text='CREA TU OFRENDA'
          functionClick={ () => btnCrearOfrenda() } 
        />
        </div>
      </section>
      <section id='ofrendas-app'>
        <div id="app"></div>
      </section>
    </div>
  )
}



export default Offerings
